import { render } from "./UserInfoAttendant.vue?vue&type=template&id=04a5f03d&scoped=true"
import script from "./UserInfoAttendant.vue?vue&type=script&lang=js"
export * from "./UserInfoAttendant.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./UserInfoAttendant.vue?vue&type=style&index=1&id=04a5f03d&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a5f03d"]])

export default __exports__